import { useState } from 'react';

import useEBTChargeAmountQuery from 'api/queries/useEBTChargeAmountQuery';

import EBTDeleteCardModal from './EBTDeleteCardModal';

/**
 * Displays EBT card information with delete functionality
 *
 * @param {Object} props - Component props
 * @param {Object} props.ebtCard - EBT card data with last4 property
 * @param {boolean} props.isDeleting - Whether card is being deleted
 * @param {Function} props.deleteCard - Delete callback function
 * @param {string|null} props.marketCloseDate - Market close date string
 */
export default function EBTCardDisplay({ clearErrors, deleteCard, deleteError, ebtCard, isDeleting, marketCloseDate }) {
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const { data: ebtChargeAmountData, isLoading: isEBTChargeAmountLoading } = useEBTChargeAmountQuery();
    const ebtAmount = ebtChargeAmountData?.ebtAmount;

    if (!ebtCard?.last4) {
        return null;
    }

    return (
        <div className="mt-20 lg:mt-0">
            <h3 className="text-body-md mb-5 text-grey">EBT CARD</h3>
            <p className="text-body-md text-grey">Card: **** **** **** {ebtCard?.last4}</p>
            <button type="button" className="link text-body-sm mt-5 block" onClick={() => setOpenDeleteModal(true)}>
                Delete
            </button>
            {openDeleteModal && (
                <EBTDeleteCardModal
                    open={openDeleteModal}
                    onClose={() => setOpenDeleteModal(false)}
                    deleteCard={deleteCard}
                    isDeleting={isDeleting}
                    deleteError={deleteError}
                    clearErrors={clearErrors}
                    ebtAmount={ebtAmount}
                    isEBTChargeAmountLoading={isEBTChargeAmountLoading}
                    marketCloseDate={marketCloseDate}
                />
            )}
        </div>
    );
}
